import { QuestionHotelPolicyAmenities } from "./amenities/root";
import { QuestionHotelPolicyBase } from "./base/root";
import { QuestionHotelPolicyCancelPolicy } from "./cancel-policy/root";
import { QuestionHotelPolicyKidsPolicy } from "./kids-policy/root";
import { QuestionPostBookingSurveySettings } from "./post-booking-survey/root";
import { QuestionReservationAdditionalFeeSettings } from "./reservation-additional-fee/root";
import { QuestionReservationBaseSettings } from "./reservation-base/root";
import { QuestionReservationLocalPaymentSettings } from "./reservation-local-payment/root";
import { QuestionReservationPlanSettings } from "./reservation-plan/root";
import { QuestionReservationQuestionSettings } from "./reservation-questions/root";
import { QuestionReservationRequest } from "./reservation-request/root";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../store/categories";

type Props = {
	hotelPolicyCategoriesAndManagerStore: Omit<
		HotelPolicyCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
};

export const HotelPolicyDefaultEditForm = ({ hotelPolicyCategoriesAndManagerStore }: Props) => {
	const {
		base, //
		amenities,
		cancelPolicy,
		kidsPolicy,
		reservationBaseSettings,
		reservationPlanSettings,
		reservationQuestionSettings,
		postBookingSurveySettings,
		reservationLocalPaymentSettings,
		reservationRequestReservationSettings,
		reservationAdditionalFeeSettings,
	} = hotelPolicyCategoriesAndManagerStore;

	return (
		<>
			<QuestionHotelPolicyBase base={base} />
			<QuestionHotelPolicyAmenities amenities={amenities} />
			<QuestionHotelPolicyCancelPolicy cancelPolicy={cancelPolicy} />
			<QuestionHotelPolicyKidsPolicy kidsPolicy={kidsPolicy} />
			<QuestionReservationBaseSettings reservationBaseSettings={reservationBaseSettings} />
			<QuestionReservationPlanSettings reservationPlanSettings={reservationPlanSettings} />
			<QuestionReservationQuestionSettings reservationQuestionSettings={reservationQuestionSettings} />
			<QuestionPostBookingSurveySettings postBookingSurveySettings={postBookingSurveySettings} />
			<QuestionReservationLocalPaymentSettings
				reservationLocalPaymentSettings={reservationLocalPaymentSettings}
			/>
			<QuestionReservationRequest reservationRequestReservationSettings={reservationRequestReservationSettings} />
			<QuestionReservationAdditionalFeeSettings
				reservationAdditionalFeeSettings={reservationAdditionalFeeSettings}
			/>
		</>
	);
};

HotelPolicyDefaultEditForm.displayName = "HotelPolicyDefaultEditForm";
